import React from "react";
import { SVG, IconProps } from "../SVG";

export const KoraMessage = (props: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" {...props}>
        <path
            fill="url(#kora_message_32_svg__a)"
            d="M20.722 4.333c5.306 0 9.612 4.338 9.612 9.663s-4.306 9.664-9.612 9.664h-7.347l-.209.202-.01.01-3.743 3.523a1 1 0 0 1-1.685-.729v-3.672l-.513-.243-.314-.154a9.705 9.705 0 0 1-5.234-8.6c0-5.326 4.306-9.664 9.612-9.664h9.443Zm-9.443 2c-4.19 0-7.612 3.432-7.612 7.663 0 2.963 1.729 5.69 4.397 6.944l.004.002 1.088.517.572.271v2.622l2.056-1.936.49-.475.291-.28h8.157c4.19 0 7.612-3.434 7.612-7.665s-3.422-7.663-7.612-7.663h-9.443Z"
        />
        <path
            fill="url(#kora_message_32_svg__b)"
            d="M17.47 12.525 21 13.998l-3.53 1.473L15.999 19l-1.473-3.53L11 13.999l3.525-1.473L15.998 9l1.473 3.525Z"
        />
        <defs>
            <linearGradient
                id="kora_message_32_svg__a"
                x1={6.743}
                x2={24.648}
                y1={24.75}
                y2={5.765}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#365FC1" />
                <stop offset={0.494} stopColor="#3667E9" />
                <stop offset={0.856} stopColor="#638EFF" />
            </linearGradient>
            <linearGradient
                id="kora_message_32_svg__b"
                x1={12.771}
                x2={20.375}
                y1={17.75}
                y2={11.188}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#365FC1" />
                <stop offset={0.494} stopColor="#3667E9" />
                <stop offset={0.856} stopColor="#638EFF" />
            </linearGradient>
        </defs>
    </SVG>
);

KoraMessage.displayName = "KoraMessage";
